<template>
	<div class="full" style="background-color: white;">
		<div class="module_container full" style="position: relative;">
			<el-container class="full" style="position: relative;">
				<el-main class="main flex">
					<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" :loading="loading"
						@toolbar-button-click="list_toolbarButtonClickEvent" ref="campaignList" ></vxe-grid>
				</el-main>
			</el-container>
		</div>
		<taskIndex ref="taskIndex" />
		<planIndex ref="planIndex" @modalhide="planFormHide" />
		<editForm ref="campaignForm" :data="currentrow" :ids="ids" @success="editFormSuccess" />
	</div>
</template>
<style scoped>
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;

	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import taskIndex from '../task/index.vue'
	import planIndex from '../plan/index.vue'
	import editForm from '../edit/form.vue'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				type:'keyword',
				activeName:'first',
				loading:false,
				currentrow:{},
				planList:[],
				shopList:[],
				ids:[],
				list_formConfig: [{
					field: 'shopname',
					title: '店铺',
					itemRender: {
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[]
						}
					}
				},{
					field: 'campaignId',
					title: '计划ID',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'campaignName',
					title: '计划名称',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'campaignGroupName',
					title: '分组名称',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'bidTypeV2',
					title: '出价方式',
					itemRender: {
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[{
								value:'smart_bid',
								label:'智能出价'
							},{
								value:'custom_bid',
								label:'手动出价'
							}]
						}
					}
				},{
					field: 'status',
					title: '状态',
					itemRender: {
						name: '$select',
						props:{
							selectoptions:[{
								value:'1',
								label:'开启'
							},{
								value:'0',
								label:'关闭'
							}]
						}
					}
				},{
					field: 'plan',
					title: '定时计划',
					itemRender: {
						name: '$select',
						props:{
							selectoptions:[]
						}
					}
				},{
					field: 'baseconstraintValue_dir_conv',
					title: '平均成交成本(基准值)',
					itemRender: {
						name: '$inputNumber',
						props:{
							islist:true
						}
					}
				},{
					field: 'baseconstraintValue_click',
					title: '平均点击成本(基准值)',
					itemRender: {
						name: '$inputNumber',
						props:{
							islist:true
						}
					}
				},{
					field: 'basedayBudget',
					title: '每日预算(基准值)',
					itemRender: {
						name: '$inputNumber',
						props:{
							islist:true
						}
					}
				},{
					field: 'record',
					title: '最近执行任务',
					itemRender: {
						name: '$select',
						props:{
							emptyoption:false,
							selectoptions:[{
								value:'success',
								label:'成功'
							},{
								value:'fail',
								label:'失败'
							}]
						}
					}
				}],
				list_columns: [{
						type: 'checkbox',
						title: '#',
						width:50,
						fixed:'left'
					},{
						field: 'campaignId',
						title: '计划ID',
						width: 100,
						fixed:'left'
					},
					// {
					// 	field: 'type',
					// 	title: '模块',
					// 	width: 100,
					// },
					{
						field: 'shopname',
						title: '店铺',
						width: 100,
					},
					{
						field: 'campaignName',
						title: '计划名称',
						width: 100,
					},
					{
						field: 'campaignGroupName',
						title: '分组名称',
						width: 100,
					},
					{
						field: 'status',
						title: '状态',
						width: 100,
						slots: {
							default: ({row}) => {
								if(row.status == 1){
									return '开启'
								}else if(row.status == 0){
									return '关闭'
								}else{
									return null
								}
		
							}
						}
					},
					{
						field: 'bidTypeV2',
						title: '出价方式',
						width: 100,
						slots: {
							default: ({row}) => {
								if( row.bidTypeV2 == 'custom_bid'){
									return '手动出价'
								}
								if( row.bidTypeV2 == 'smart_bid'){
									return '智能出价'
								}
								return null
							}
						}
					},
					{
						field: 'current',
						title: '当前值',
						align:'center',
						children:[{
							field: 'currentconstraintValue_dir_conv',
							title: '平均成交成本',
							width: 60,
						},
						{
							field: 'currentconstraintValue_click',
							title: '平均点击成本',
							width: 60,
						},
						{
							field: 'currentdayBudget',
							title: '每日预算',
							width: 60,
						}]
					},
					{
						field: 'base',
						title: '基准值',
						align:'center',
						children:[{
							field: 'baseconstraintValue_dir_conv',
							title: '平均成交成本',
							width: 60,
						},
						{
							field: 'baseconstraintValue_click',
							title: '平均点击成本',
							width: 60,
						},
						{
							field: 'basedayBudget',
							title: '每日预算',
							width: 60,
						}]
					},
					{
						field: 'plan',
						title: '定时计划',
						fixed: "right",
						width: 120,
					},
					{
						field: 'record',
						title: '最近执行任务',
						fixed: "right",
						width: 250,
				
						slots: {
							default: ({row}) => {
								let arr = []
								row.record.forEach((item,index)=>{
									let type = 'success'
									if(row.error[index]!='成功'){
										type = 'danger'
									}
									arr.push(<el-tag size="mini" type={type}>{item}</el-tag>)
								})
								return arr
							}
						}
					},
					{
						field: 'count',
						title: '执行次数',
						fixed: "right",
						sortable:true,
						width: 60,
					},
					{
						field: 'update_time',
						title: '最近拉取时间',
						fixed: "right",
						sortable:true,
						formatter:'date',
						width: 100,
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			listplan(){
				return new Promise((reslove)=>{
					this.$api.campaign.listplan({
						type:this.type
					}).then((res)=>{
						this.planList = res.list
						this.shopList = res.shop
						reslove()
					})
				})
			},
			
			list_beforeCreateGrid(gridOptions) {
				return new Promise((reslove)=>{
					this.listplan().then(()=>{
						this.list_formConfig.forEach((item)=>{
							if(item.field == 'plan'){
								item.itemRender.props.selectoptions = this.planList.map((item)=>{									
									return {
										label:item.name,
										value:item.id
									}
								})
							}
							if(item.field == 'shopname'){
								item.itemRender.props.selectoptions = this.shopList.map((item)=>{
									return {
										label:item.code,
										value:item.code
									}
								})
							}
						})		
						this.list_columns.forEach((item)=>{
							if(item.field == 'plan'){
								item.slots = {
									default: ({row}) => {
										let target = this.planList.find((item)=>{											
											return item.id == row.plan
										})
										// let enable = item.enabe == 5?'【启用】':'【暂停】'
										return target?(target.name):null
									}
								}
							}
						})
						gridOptions.tooltipConfig.contentMethod = ({row,column}) => {
							if(column.field == 'record'){
								let content = []
								row.record.forEach((item,index)=>{
									content.push(item+'：'+row.error[index])
								})
								return content.join("\n")
							}else{
								if (row && column.field) {
									return row[column.field]
								} else {
									return ''
								}
							}

						}
	
						gridOptions.showOverflow = false
						// gridOptions.scrollY = {
						// 	enabled:false
						// }
						gridOptions.pagerConfig = {
							enabled: false,
							autoHidden: false,
							border: true,
							size: 'mini',
							perfect: false,
							currentPage: 1,
							pageSize: 20,
							pageSizes: [10, 20, 50, 100, 200, 5000],
						}				
						gridOptions.formConfig.span = 4
						gridOptions.pagerConfig.enabled = true				
						gridOptions.toolbarConfig.buttons = [{
							name: '导出',
							status: 'success',
							code: 'export'
						},{
							name: '编辑任务',
							status: 'primary',
							code: 'task'
						},{
							name: '定时计划',
							status: 'danger',
							code: 'plan'
						},{
							name: '全量拉取',
							status: 'warning',
							code: 'pull'
						},{
							name: '更新基准值',
							status: 'success',
							code: 'updatebase'
						},{
							name: '批量设置定时计划',
							status: '',
							code: 'batchsetplan'
						}]		
						reslove()
					})
				})				
			},
			batchsetplan(){
				this.currentrow = {}
				let data = this.$refs.campaignList.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.ids = data.map((item)=>{
					return item.id
				})
				this.$refs.campaignForm.modal_show()
				
			},
			pull(){				
				this.$confirm('全量拉取不会更新基准值，是否确认拉取 ' , '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.campaign.pull({
						type:this.type
					}).then(() => {
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})	
				}).catch(() => {
			
				})
				
			
			},
			updatebase(){
				let data = this.$refs.campaignList.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let ids = data.map((item)=>{
					return item.id
				})
				this.loading = true
				this.$api.campaign.updatebase({ids:ids}).then(() => {
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})				
			},
			edit(row){
				this.currentrow = row
				this.$refs.campaignForm.modal_show()
				// console.log(row)
			},
			task(){
				this.$refs.taskIndex.modal_show()
			},
			plan(){
				this.$refs.planIndex.modal_show()
			},
			list(page, updateForm) {
				return new Promise((resolve) => {
					this.$api.campaign.list({
						type:this.type,
						...page,
						...updateForm
					}).then((res) => {
						resolve(res)
					},()=>{
						resolve()
					})
				})
			},
			editFormSuccess(){
				this.ids = []
				this.customreload()
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			},
			planFormHide(){
				// this.list_gridOptions = null
				this.list_init()
			},
			customreload() {
				this.$refs.campaignList.commitProxy('query')
			}
		},
		components: {
			taskIndex,
			planIndex,
			editForm
		}
	}
</script>